const actionTypes = {
  TABLE_LOADING: Symbol('TABLE_LOADING'),
  ALL_ROOM_TYPE_LOADING: Symbol('ALL_ROOM_TYPE_LOADING'),
  FETCH_ROOMTYPE_LIST: Symbol('FETCH_ROOMTYPE_LIST'),
  TOGGLE_ROOMTYPE_MODAL_VISIBLE: Symbol('TOGGLE_ROOMTYPE_MODAL_VISIBLE'),
  SAVE_CURRENT_ROOMTYPE: Symbol('SAVE_CURRENT_ROOMTYPE'),
  FETCH_ALL_ROOMTYPE: Symbol('FETCH_ALL_ROOMTYPE'),
  FETCH_ROOM_CATEGORIES: Symbol('FETCH_ROOM_CATEGORIES'),
  RELOAD_ROOMTYPE_LIST: Symbol('RELOAD_ROOMTYPE_LIST'),
  FETCH_ROOM_TYPE_DETAIL: Symbol('FETCH_ROOM_TYPE_DETAIL'),
  TOGGLE_ROOMTYPE_NEW_MODAL_VISIBLE: Symbol('TOGGLE_ROOMTYPE_NEW_MODAL_VISIBLE'),
  UPDATE_CURRENT_ROOM_TYPEL: Symbol('UPDATE_CURRENT_ROOM_TYPEL'),
  FETCH_TAG_LIST: Symbol('FETCH_TAG_LIST'),
  UPDATE_ROOM_TYPE_INFO: Symbol('UPDATE_ROOM_TYPE_INFO'),
};

export default actionTypes;
